module.exports = __webpack_public_path__ + "static/media/lympne-9.f613e9c9.jpg";